import type { MRT_ColumnDef } from "mantine-react-table-open";
import { backendDateOrDateTimeToLuxonDateTime } from "../../../../../utils/dates/backendDateOrDateTimeToLuxonDateTime";
import { DATE_DISPLAY_FORMAT } from "../../../../../utils/dates/dates.constants";
import type { PPAContract } from "../../PPAContractPage.types";

export function getBeginColumn(): MRT_ColumnDef<PPAContract> {
  return {
    accessorKey: "start_date",
    accessorFn: (row) =>
      backendDateOrDateTimeToLuxonDateTime(row.start_date).toJSDate(),
    header: "Vertragsbeginn",
    Cell: ({ row }) =>
      backendDateOrDateTimeToLuxonDateTime(row.original.start_date).toFormat(
        DATE_DISPLAY_FORMAT
      ),
    filterVariant: "date-range"
  };
}
